/** 派工明细汇总：列定义（列设置 / 表头 / 筛选 / 导出共用） */

export const DISPATCH_LINE_DETAIL_COLUMNS_DEFAULT = [
  { prop: 'dispatch_order_no', label: '派工单', labelFull: '派工单号', width: 100, visible: true, fixed: 'left', filterType: 'text' },
  { prop: 'dispatch_status_label', label: '状态', labelFull: '执行状态', width: 64, visible: true, filterType: 'select', filterOptions: ['草稿', '已指派', '进行中', '已完成', '已取消'] },
  { prop: 'audit_status_label', label: '审核', labelFull: '派工审核', width: 64, visible: true, filterType: 'select', filterOptions: ['待审核', '已通过', '已拒绝'] },
  { prop: 'warehouse_completed_label', label: '已完工', labelFull: '仓库已完工', width: 64, visible: false, filterType: 'select', filterOptions: ['是', '否'] },
  { prop: 'is_not_assigned_label', label: '未指派', labelFull: '尚未指派人员', width: 64, visible: false, filterType: 'select', filterOptions: ['是', '否'] },
  { prop: 'post_completion_audit_label', label: '核销', labelFull: '现场核销', width: 64, visible: false, filterType: 'select', filterOptions: ['—', '待核销', '已核销', '核销驳回'] },
  { prop: 'assigned_user_name', label: '指派', labelFull: '指派人员', width: 72, visible: true, filterType: 'select', filterDynamic: true },
  { prop: 'packaging_operator_name', label: '包装人', labelFull: '包装填写负责人', width: 72, visible: false, filterType: 'select', filterDynamic: true },
  { prop: 'mobile_slitting_progress', label: '分卷', labelFull: '分卷确认进度', width: 56, visible: true, filterType: 'text' },
  { prop: 'required_completion_at', label: '要求完成', labelFull: '要求完成时间', width: 96, visible: false, filterType: 'text' },
  { prop: 'order_no', label: '订单号', labelFull: '订单号', width: 100, visible: true, filterType: 'text' },
  { prop: 'client_purchase_order', label: '采购单', labelFull: '客户采购单号', width: 110, visible: true, exportAlways: true, filterType: 'text' },
  { prop: 'order_notes', label: '订单备注', labelFull: '订单备注', width: 120, visible: true, exportAlways: true, filterType: 'text' },
  { prop: 'client_style_no', label: '款号', labelFull: '客户款号', width: 96, visible: true, filterType: 'text' },
  { prop: 'client_instruct_no', label: '指令号', labelFull: '客户指令号', width: 96, visible: true, filterType: 'text' },
  { prop: 'warehouse_manual_code', label: '仓库料号', labelFull: '仓库材料料号', width: 108, visible: true, filterType: 'text' },
  { prop: 'stock_location_display', label: '库位', labelFull: '材料库位', width: 120, visible: true, filterType: 'text' },
  { prop: 'order_date', label: '订单日', labelFull: '订单日期', width: 88, visible: false, filterType: 'text' },
  { prop: 'customer_name', label: '客户', labelFull: '客户', width: 88, visible: true, filterType: 'select', filterDynamic: true },
  { prop: 'brand_name', label: '品牌', labelFull: '品牌', width: 72, visible: false, filterType: 'select', filterDynamic: true },
  { prop: 'season_display', label: '季节', labelFull: '季节', width: 72, visible: false, filterType: 'select', filterDynamic: true },
  { prop: 'order_type_display', label: '类型', labelFull: '订单类型', width: 72, visible: false, filterType: 'select', filterDynamic: true },
  { prop: 'client_material_name', label: '客户材料', labelFull: '客户材料名称', width: 110, visible: true, filterType: 'text' },
  { prop: 'client_color_cn', label: '客户色', labelFull: '客户颜色', width: 80, visible: true, filterType: 'select', filterDynamic: true },
  { prop: 'client_color_en', label: '客户英色', labelFull: '客户英文颜色', width: 88, visible: false, filterType: 'select', filterDynamic: true },
  { prop: 'internal_product_name', label: '内部材料', labelFull: '内部材料名称', width: 100, visible: false, filterType: 'select', filterDynamic: true },
  { prop: 'internal_color_cn', label: '内部色', labelFull: '内部颜色', width: 80, visible: false, filterType: 'select', filterDynamic: true },
  { prop: 'internal_color_en', label: '内部英色', labelFull: '内部英文颜色', width: 88, visible: false, filterType: 'select', filterDynamic: true },
  { prop: 'specification', label: '规格', labelFull: '规格', width: 88, visible: false, filterType: 'text' },
  { prop: 'item_notes_1', label: '备注1', labelFull: '销售订单明细备注一', width: 100, visible: true, exportAlways: true, filterType: 'text' },
  { prop: 'item_notes_2', label: '备注2', labelFull: '销售订单明细备注二', width: 100, visible: true, exportAlways: true, filterType: 'text' },
  { prop: 'item_notes_3', label: '备注3', labelFull: '销售订单明细备注三', width: 100, visible: true, exportAlways: true, filterType: 'text' },
  { prop: 'material_usage_notes', label: '用料', labelFull: '用料备注', width: 88, visible: false, filterType: 'text' },
  { prop: 'matching_remarks', label: '配料备注', labelFull: '配料备注', width: 100, visible: false, filterType: 'text' },
  { prop: 'order_line_quantity', label: '单量', labelFull: '订单数量', width: 64, visible: true, align: 'right', filterType: 'text' },
  { prop: 'merged_quantity', label: '合并量', labelFull: '合并数量', width: 64, visible: true, align: 'right', filterType: 'text', slot: 'merged_quantity' },
  { prop: 'merge_group_line_count', label: '组行', labelFull: '合并组行数', width: 48, visible: false, align: 'center', filterType: 'text' },
  { prop: 'is_merge_group_label', label: '合并', labelFull: '合并打码', width: 56, visible: true, align: 'center', filterType: 'select', filterOptions: ['是', '否'], slot: 'merge_group' },
  { prop: 'merge_group_key', label: '组键', labelFull: '合并组标识', width: 72, visible: false, filterType: 'text' },
  { prop: 'unit_name', label: '单位', labelFull: '单位', width: 48, visible: true, filterType: 'select', filterDynamic: true },
  { prop: 'warehouse_code', label: '料号', labelFull: '已选料号', width: 88, visible: true, filterType: 'text' },
  { prop: 'packaging_type_label', label: '袋型', labelFull: '袋型', width: 56, visible: true, filterType: 'select', filterOptions: ['未指定', '透明袋', '蛇皮袋'] },
  { prop: 'packaging_require_weigh', label: '称重', labelFull: '需称重', width: 48, visible: true, align: 'center', filterType: 'yn', slot: 'yn_weigh' },
  { prop: 'packaging_require_volume', label: '体积', labelFull: '需量体积', width: 48, visible: true, align: 'center', filterType: 'yn', slot: 'yn_volume' },
  { prop: 'slitting_confirmed_label', label: '分卷确', labelFull: '本分卷已确认', width: 56, visible: true, filterType: 'select', filterOptions: ['是', '否'] },
  { prop: 'slitting_confirmed_at', label: '确认时', labelFull: '分卷确认时间', width: 96, visible: false, filterType: 'text' },
  { prop: 'slitting_confirmed_by_name', label: '确认人', labelFull: '分卷确认人', width: 72, visible: false, filterType: 'select', filterDynamic: true },
  { prop: 'branch_count', label: '支数', labelFull: '分码支数', width: 48, visible: true, align: 'center', filterType: 'text' },
  { prop: 'branch_codes_complete_label', label: '码齐', labelFull: '分码编号齐', width: 48, visible: true, filterType: 'select', filterOptions: ['是', '否'] },
  { prop: 'packaging_measures_complete_label', label: '包齐', labelFull: '包装实测齐', width: 48, visible: true, filterType: 'select', filterOptions: ['是', '否'] },
  { prop: 'branch_qty_sum', label: '码量合', labelFull: '分码数量合计', width: 64, visible: false, align: 'right', filterType: 'text' },
  { prop: 'branch_line_no', label: '序号', labelFull: '分码序号', width: 48, visible: false, align: 'center', filterType: 'text' },
  { prop: 'branch_label', label: '标签', labelFull: '分码标签', width: 48, visible: true, align: 'center', filterType: 'text' },
  { prop: 'branch_pack_code', label: '包装号', labelFull: '包装编号', width: 120, visible: true, filterType: 'text' },
  { prop: 'branch_quantity', label: '支量', labelFull: '本支数量', width: 56, visible: true, align: 'right', filterType: 'text' },
  { prop: 'branch_weight_kg', label: 'kg', labelFull: '称重kg', width: 52, visible: true, align: 'right', filterType: 'text' },
  { prop: 'branch_dims_display', label: '尺寸', labelFull: '外尺寸cm', width: 80, visible: true, filterType: 'text' },
  { prop: 'branch_fold_compensation', label: '折补', labelFull: '折补', width: 48, visible: false, align: 'center', filterType: 'yn', slot: 'yn_fold' },
  { prop: 'branch_fold_compensation_qty', label: '折量', labelFull: '折补数量', width: 56, visible: false, align: 'right', filterType: 'text' },
  { prop: 'packaging_measured_by_name', label: '录入', labelFull: '包装录入人', width: 72, visible: true, filterType: 'select', filterDynamic: true },
  { prop: 'packaging_measured_at', label: '录入时', labelFull: '包装录入时间', width: 96, visible: false, filterType: 'text' },
  { prop: 'has_delivery_order_label', label: '已送货', labelFull: '已开送货单', width: 56, visible: false, exportAlways: true, filterType: 'select', filterOptions: ['是', '否'] },
  { prop: 'delivery_order_nos', label: '送货单', labelFull: '送货单号', width: 100, visible: false, exportAlways: true, filterType: 'text' },
  { prop: 'dispatch_notes', label: '派工注', labelFull: '派工单备注', width: 88, visible: false, filterType: 'text' }
]

/** 列筛选面板用：含全部可筛列（与表格是否显示该列无关） */
export const DISPATCH_LINE_DETAIL_FILTER_COLUMNS = DISPATCH_LINE_DETAIL_COLUMNS_DEFAULT.filter((c) => c.filterType)

export function buildDistinctColumnFilterOptions(rows, prop) {
  const set = new Set()
  for (const row of rows || []) {
    const v = row?.[prop]
    if (v == null || String(v).trim() === '') continue
    set.add(String(v).trim())
  }
  return Array.from(set).sort((a, b) => a.localeCompare(b, 'zh-CN'))
}

export function resolveLineDetailColumnFilterOptions(col, rows) {
  if (!col) return []
  if (col.filterOptions?.length) return col.filterOptions
  if (col.filterType === 'yn') return ['是', '否']
  if (col.filterDynamic) return buildDistinctColumnFilterOptions(rows, col.prop)
  return []
}

export function resolveLineDetailExportColumns(columnConfig) {
  const config = Array.isArray(columnConfig) ? columnConfig : DISPATCH_LINE_DETAIL_COLUMNS_DEFAULT
  const configByProp = new Map(config.map((c) => [c.prop, c]))
  return DISPATCH_LINE_DETAIL_COLUMNS_DEFAULT.filter((def) => {
    const saved = configByProp.get(def.prop)
    const merged = saved ? { ...def, ...saved } : def
    return merged.visible !== false || merged.exportAlways === true || def.exportAlways === true
  }).map((def) => {
    const saved = configByProp.get(def.prop)
    return saved ? { ...def, ...saved } : { ...def }
  })
}

export function getCellDisplayValue(row, col) {
  if (!row || !col) return ''
  const v = row[col.prop]
  if (col.filterType === 'yn') {
    if (v === true) return '是'
    if (v === false) return '否'
  }
  if (v == null || v === '') return ''
  return String(v)
}

export function matchColumnFilter(row, col, filterVal) {
  const q = (filterVal || '').trim()
  if (!q) return true
  const cell = getCellDisplayValue(row, col)
  const s = cell === '' ? '' : String(cell)
  if (col.filterType === 'select' || col.filterType === 'yn') {
    return s === q
  }
  return s.toLowerCase().includes(q.toLowerCase())
}

export function applyLineDetailColumnFilters(rows, columnFilters, columns = DISPATCH_LINE_DETAIL_FILTER_COLUMNS) {
  const list = Array.isArray(rows) ? rows : []
  const active = columns.filter((c) => {
    const v = columnFilters[c.prop]
    return v != null && String(v).trim() !== ''
  })
  if (!active.length) return list
  return list.filter((row) => active.every((col) => matchColumnFilter(row, col, columnFilters[col.prop])))
}

export function loadLineDetailColumnConfig(storageKey) {
  try {
    const saved = localStorage.getItem(`${storageKey}_columns_config`)
    if (!saved) return DISPATCH_LINE_DETAIL_COLUMNS_DEFAULT.map((c) => ({ ...c }))
    const parsed = JSON.parse(saved)
    if (!Array.isArray(parsed)) return DISPATCH_LINE_DETAIL_COLUMNS_DEFAULT.map((c) => ({ ...c }))
    const savedProps = new Set(parsed.map((c) => c.prop))
    const merged = parsed.map((savedCol) => {
      const def = DISPATCH_LINE_DETAIL_COLUMNS_DEFAULT.find((c) => c.prop === savedCol.prop)
      return def ? { ...def, ...savedCol } : { ...savedCol }
    })
    DISPATCH_LINE_DETAIL_COLUMNS_DEFAULT.forEach((def) => {
      if (!savedProps.has(def.prop)) merged.push({ ...def })
    })
    return merged
  } catch {
    return DISPATCH_LINE_DETAIL_COLUMNS_DEFAULT.map((c) => ({ ...c }))
  }
}

export function saveLineDetailColumnConfig(storageKey, config) {
  try {
    localStorage.setItem(`${storageKey}_columns_config`, JSON.stringify(config))
  } catch {
    /* ignore */
  }
}
